module.exports = __webpack_public_path__ + "static/profile-c7ec526758d7c55b27383c7c45cc5336.png";